import { Component, ViewChild, Input, Output, OnChanges, EventEmitter  } from '@angular/core';
import { ServiceHeaderDirective } from '../../../service-header/service-header.directive';
import { IframeResizeDirective } from '../../../../../common';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { Service } from './org-vdc-wizard.service';
import { ClrWizard } from '@clr/angular';
import { ComputeVcdConstants } from '../compute-vcd-constants';
let $ = require('jquery');
const _ = require('lodash');
@Component({
  selector: 'create-org-vdc-wizard',
  styles: [require('./org-vdc.wizard.scss')],
  template: require('./create-org-vdc.wizard.html'),
   providers: [
    Service
  ]
})

export class CreateOrgVdcWizard {
  @ViewChild('wizard') wizard: ClrWizard;
  @Input() isWizardOpen: boolean = false;
  @Input() isEdit: boolean = false;
  @Input() orgVdcId: string = '';
  @Output() wizStatusChange: EventEmitter<any> = new EventEmitter();

  private disableStep0: boolean = true;
  private disableStep1: boolean = true;
  private disableStep2: boolean = true;
  private orgList: JSON;

  private descVdcData1: any;
  private stepData = [];
  private currentStepData = [];
  private editData = [];
  private subscribeHandler;
  private crudResult = [];
  private wizardType: string = 'Create';
  private stepDataForSddcPool: any;
  private sddcStepData: any;
  constructor(public service: Service) {
    // todo
  }

  ngOnInit() { 
  }

  resetWizard() {
      this.wizard.reset();
      this.isWizardOpen = false;
      this.descVdcData1 = null;
      this.stepData = [];
      this.editData = [];
      this.toggleNextButtonState (true);
      $( '.datagrid-column-title .checkbox').hide();
  }

  ngOnChanges(changes) {
      // todo
  }

  getEditData() {
    this.subscribeHandler = this.service.getVirtualdc(this.orgVdcId)
      .subscribe(
        (editData: any) => {
          this.editData = editData;
          this.isEdit = true;
        },
        error => this.service.logError(error, 'get Edit data error'),
        () => this.service.logOperationCompleted('get Edit data Completed')
    );
  }

  toggleNextButtonState(state: boolean) {
    this.disableStep0 = state;
    this.disableStep1 = state;
    this.disableStep2 = state;
  }

  nextButtonClicked(stepId) {
    if (stepId === 0) {
        this.stepDataForSddcPool = _.cloneDeep(this.stepData[0]);
    }
    if (stepId === 1) {
        this.sddcStepData = _.cloneDeep(this.stepData[1]);
    }
    if (stepId === 3) {
        this.postData();
    }
  }

  wizardStateChanged(isItOpen) {
    this.isWizardOpen = false;
    this.isEdit = false;
    this.wizStatusChange.emit(isItOpen);
  }

  onOrgChange(event) {
    this.stepData[event.stepId] = event;
  }

  isWizardOpenChange() {
  }

  toggleNextButton(event) {
    this.currentStepData = event;
    this.stepData[event.stepId] = event;
    if (event.stepId >= 0 && event.stepId <= 2) {
        this['disableStep' + event.stepId] =  (event.isStepValid) ? false : true;
    }
  }

  getStorageProfiles() {
      let data = [];
      for (let i = 0; i < this.stepData[2].storageProfiles.length; ++i) {
        let profile = this.stepData[2].storageProfiles[i];
        if (profile.isDeleted) {
            continue;
        }
        let iops;
        if (profile.iopsSettings.enabled) {
          iops = {
              diskIopsDefault: profile.iopsSettings.diskIopsDefault,
              enabled: true,
              storageProfileIopsLimit: profile.iopsSettings.storageProfileIopsLimit
            };
        } else {
          iops = {
              enabled: false
            };
        }
        data.push({
            pvdcStorageProfileId : profile.objectId,
            limit: profile.storage * 1024,
            unit: 'MB',
            iopsSettings : iops,
            default : profile.default
        });

      }
    return data;
  }

  postData() {
    let vdcSpec;
    let cpuGuarantee: number = 0;
    let memoryGuarantee: number = 0;

    if (this.stepData[2].allocModel === ComputeVcdConstants.ALLOC_MODEL.ALLOCPOOL) {
        cpuGuarantee = Number(this.stepData[2].cpuGuarantee);
        cpuGuarantee = (cpuGuarantee > 0 ) ? cpuGuarantee / 100 : cpuGuarantee;
        memoryGuarantee = Number(this.stepData[2].memoryGuarantee);
        memoryGuarantee = (memoryGuarantee > 0) ? memoryGuarantee / 100 : memoryGuarantee;
    }

    vdcSpec = {
      name: this.stepData[0].name,
      description: this.stepData[0].description,
      pvdcId: this.stepData[1].selectedSDDC[0].objectId,
      allocationModel: this.stepData[2].allocModel,
      cpuCapacity: {
        allocated: (this.stepData[2].cpu) ? Number(this.stepData[2].cpu) * 1000 : 0,
        limit: (this.stepData[2].cpu) ? Number(this.stepData[2].cpu) * 1000 : 0,
        unit: 'MHz'
      },
      memoryCapacity: {
        allocated: (this.stepData[2].memory) ? Number(this.stepData[2].memory) * 1024 : 0,
        limit: (this.stepData[2].memory) ? Number(this.stepData[2].memory) * 1024 : 0,
        unit: 'MB'
      },
      storageProfiles : this.getStorageProfiles(),
      resourceGuaranteedCpu: cpuGuarantee,
      resourceGuaranteedMemory: memoryGuarantee
    };

    this.subscribeHandler = this.service.createOrgVDC(vdcSpec, this.stepData[0].selectedOrgId)
      .subscribe(
          (crudResult: any) => {
            this.crudResult = crudResult;
          },
        error => this.service.logError(error, 'Add OrgVdc error'),
        () => this.service.logOperationCompleted('Add OrgVdc Completed')
      );
    }

};



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/org-vdc-wizard/create-org-vdc.wizard.ts